<div class="upload-file-wrapper">
  <input class="d-none" type="file" (change)="onFileChanged($event.target.files)" #fileInput
    (click)="fileInput.value = null" multiple>

  <div class="drop-img-bg" (click)="fileInput.click()" appDragAndDrop (onFileDropped)="onFileChanged($event)">
    <div class="placeholder-text">{{placeholder}}</div>
  </div>
</div>